<template>
  <div class="videos" v-bind:class="{ 'justify-content-start' : items.length <= 3}">
    <div class="video-card" v-for="item in filteredItems" :key="item.id">
      <router-link :to="{name: 'fan-playlist-detail', params: { id: item.id }, query: relatedQuery}">
        <div class="thumb" :style="thumbStyle(item)">
          <div class="length" v-if="item.videos.length > 1">
            {{ item.videos.length }} videos
          </div>
          <div class="length" v-if="item.videos.length == 1">
            {{ item.videos.length }} video
          </div>
          <div class="length" v-if="item.videos.length == 0">
            empty
          </div>
        </div>
      </router-link>
      <div class="info">
        <router-link class="title" :to="{name: 'fan-playlist-detail', params: { id: item.id }, query: relatedQuery}">
          {{ item.name }}
        </router-link>
        <div class="creator">
          Created by <router-link :to="{name: 'fan-profile', params: { id: item.profile.id }}">{{ creatorName(item) }}</router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';
  @import '~bootstrap/scss/mixins/_breakpoints.scss';

  .videos {
    margin-top: 1em;
    justify-content: space-between;

    display: flex;
    flex-wrap: wrap;

    .video-card {
      /* flex-basis: 200px; */
      /* flex-basis: 22%; */
      margin: 11px;
      width: $video-width / 2.4;

      @include media-breakpoint-down(md) {
        width: $video-width / 2.8;
      }
      @include media-breakpoint-down(sm) {
        width: $video-width / 3.5;
      }
      @include media-breakpoint-down(xs) {
        width: $video-width / 3.8;
      }
      @media screen and (max-width: 360px) {
        width: $video-width / 4.7;
      }

      .thumb {
        /* width: 100%; */
        /* height: 131px; */
        height: $video-height / 2.4;
        width: $video-width / 2.4;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        margin-bottom: 5px;

        display: flex;
        justify-content: center;
        align-items: center;
        @include media-breakpoint-down(md) {
          height: $video-height / 2.8;
          width: $video-width / 2.8;
        }
        @include media-breakpoint-down(sm) {
          height: $video-height / 3.5;
          width: $video-width / 3.5;
        }
        @include media-breakpoint-down(xs) {
          height: $video-height / 3.8;
          width: $video-width / 3.8;
        }
        @media screen and (max-width: 360px) {
          height: $video-height / 4.7;
          width: $video-width / 4.7;
        }

        .length {
          padding: 5px 10px 5px 10px;
          border-radius: 4px;
          opacity: 0.68;
          background: $black;
          color: $white;
          font-size: 0.8em;
          text-align: center;

          /deep/ a:hover {
            color: $white;
          }
        }
      }

      .info {
        .title {
          color: $white;
        }

        .creator {
          font-size: 0.8em;
          color: $steel;
        }
      }
    }
  }
</style>

<script>
import { mapGetters } from 'vuex'
import map from 'lodash/map'
import { profileHelpers } from '@/store/helpers'

export default {
  name: 'PlaylistList',
  components: {
  },
  props: ['items', 'exclude'],
  computed: {
    filteredItems () {
      if (!this.exclude) return this.items
      return this.items.filter(item => item.id !== this.exclude.id)
    },
    relatedQuery () {
      if (!this.items) return {}
      return {
        related: map(this.items, 'id').join(',')
      }
    },
    ...mapGetters('profile', ['currentUser'])
  },
  methods: {
    creatorName (item) {
      if (item.profile.id === this.currentUser.id) return 'you'
      return this.displayName(item.profile)
    },
    thumbStyle (item) {
      let src = null
      for (let video of item.videos) {
        if (video.video_thumbnail) {
          src = video.video_thumbnail
          break
        }
      }

      if (src) {
        return {
          'background-image': 'url(' + src + ')'
        }
      } else {
        return {
          'background-image': 'url(/static/img/wireframe.svg)',
          'background-size': 'contain'
        }
      }
    },
    ...profileHelpers
  }
}
</script>



// WEBPACK FOOTER //
// src/components/widgets/PlaylistList.vue